/**
 * When the system is in maintenance mode (i.e. state is LIMITED and writeSafe is false), all write
 * operations in the UI will be disabled. This includes:
 * - Identify (inventory and property panel)
 * - Rename
 * - Firmware update
 * - Add/remove devices
 * - Manage gateways
 */
export interface SystemStatus {
	state: SystemState;
	writeSafe: boolean;
	schemaChanged: boolean;
}

export enum SystemState {
	Operational = 'OPERATIONAL',
	Limited = 'LIMITED',
	Suspended = 'SUSPENDED'
}
